import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Button } from "primeng/button";

export interface StatCardItem {
  title: string;
  subtitle: string;
  value: string | number;
  icon?: string; // primeicons class
  accent?: 'primary' | 'success' | 'warn';
}

@Component({
  selector: 'patient-dashboard-stats',
  standalone: true,
  imports: [CommonModule, Button],
  templateUrl: './dashboard-stats.component.html',
  styleUrls: ['./dashboard-stats.component.scss']
})
export class DashboardStatsComponent {
  @Input() cards: StatCardItem[] = [];
}
